<template>
  <div class="landing-top-header overflow-hidden">
    <div class="top sticky">
      <div class="app-sidebar__overlay"></div>

      <div class="app-sidebar bg-transparent horizontal-main">
        <div class="container">
          <div class="row">
            <div class="main-sidemenu navbar px-0">

              <!-- LOGO -->
              <router-link
                  to="/"
                  class="navbar-brand ps-0 d-none d-lg-block"
              >
                <img class="logo-2" src="/assets/images/brand/logo-dark.png" alt="CNTIPPEE">
                <img class="logo-3" src="/assets/images/brand/logo-white.png" alt="CNTIPPEE">
              </router-link>

              <!-- MENU -->
              <ul class="side-menu">

                <li class="slide">
                  <router-link to="/" exact class="side-menu__item">
                    <span class="side-menu__label">Accueil</span>
                  </router-link>
                </li>

                <li class="slide">
                  <router-link to="/projets" class="side-menu__item">
                    <span class="side-menu__label">Projets</span>
                  </router-link>
                </li>

                <li class="slide">
                  <router-link to="/actualites" class="side-menu__item">
                    <span class="side-menu__label">Actualités</span>
                  </router-link>
                </li>

                <li class="slide">
                  <router-link to="/publications" class="side-menu__item">
                    <span class="side-menu__label">Publications</span>
                  </router-link>
                </li>

                <li class="slide">
                  <router-link to="/carrieres" class="side-menu__item">
                    <span class="side-menu__label">Carrières</span>
                  </router-link>
                </li>

                <li class="slide">
                  <router-link to="/a-propos" class="side-menu__item">
                    <span class="side-menu__label">À propos</span>
                  </router-link>
                </li>

                <li class="slide">
                  <router-link to="/contact" class="side-menu__item">
                    <span class="side-menu__label">Contact</span>
                  </router-link>
                </li>

              </ul>

              <!-- ACTIONS -->
              <div class="header-nav-right d-none d-lg-flex">
                <router-link
                    to="/login"
                    class="btn ripple btn-min w-sm btn-primary my-auto"
                >
                  Connexion
                </router-link>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <HomeHero />-->
    <slot name="hero" />
  </div>
</template>

<script>
  import HomeHero from "./HomeHero.vue";

  export default {
    name: 'LandingNavbar',
    components: {HomeHero},
  }
</script>

<style scoped>

</style>
